<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
    <v-row class="m-0" style="flex: 0 0 auto;">
      <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
        <v-row>
          <v-col cols="2" class="p-1">
            <v-btn
                style="margin-top: 15px"
                icon
                color="dark-grey"
                @click="moveDate(-1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col style="padding: 12px 0">
            <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="formatedDate"
                    label="Zeitraum"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="date"
                  type="month"
                  scrollable
                  locale="de"
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="modal = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="setDate(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="2" class="p-1">
            <v-btn
                style="margin-top: 15px"
                icon
                color="dark-grey"
                @click="moveDate(1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
       <v-col sm="4" md="4" xl="4" class="pt-1 pb-0">
         <v-card v-if="currentMita !== undefined"
             class="mx-auto"
         >
           <v-card-text>
             <v-row>
               <v-col  class="p-1">
                 <v-text-field
                     class="long-label"
                     label="Überstunden Vorjahr:"
                     :value="formateUebPrevYear"
                     hide-details
                     disabled
                 ></v-text-field>
               </v-col>
               <v-col  class="p-1">
                 <v-text-field
                     class="long-label"
                     label="Überstunden geleistet:"
                     :value="formateUebPerformed"
                     hide-details
                     disabled
                 ></v-text-field>
               </v-col>
               <v-col  class="p-1">
                 <v-text-field
                     class="long-label"
                     label="Überstunden abgebaut:"
                     :value="formateUebUsed"
                     hide-details
                     disabled
                 ></v-text-field>
               </v-col>
               <v-divider class="ml-2 mr-2"
                          vertical
               ></v-divider>
               <v-col  class="p-1">
                 <v-text-field
                     :class="{'long-label': true, 'saldo': true, 'neg': uebSaldo < 0, 'pos': uebSaldo >= 0}"
                     label="Überstunden Saldo:"
                     :value="formateUebSaldo"
                     hide-details
                     disabled
                 ></v-text-field>
               </v-col>
             </v-row>
           </v-card-text>
         </v-card>
       </v-col>
      <v-col sm="4" md="4" xl="4" class="pt-1 pb-0">
        <v-card v-if="currentMita !== undefined"
                class="mx-auto"
        >
          <v-card-text>
            <v-row>
              <v-col  class="p-1">
                <v-text-field
                    class="long-label"
                    label="Urlaub Vorjahr:"
                    :value="formateHolPrevYear"
                    hide-details
                    disabled
                ></v-text-field>
              </v-col>
              <v-col  class="p-1">
                <v-text-field
                    class="long-label"
                    label="Urlaubsanspruch:"
                    :value="formateHolGranted"
                    hide-details
                    disabled
                ></v-text-field>
              </v-col>
              <v-col  class="p-1">
                <v-text-field
                    class="long-label"
                    label="Urlaub genommen:"
                    :value="formateHolUsed"
                    hide-details
                    disabled
                ></v-text-field>
              </v-col>
              <v-divider class="ml-2 mr-2"
                         vertical
              ></v-divider>
              <v-col  class="p-1">
                <v-text-field
                    :class="{'long-label': true, 'saldo': true, 'neg': holSaldo < 0, 'pos': holSaldo >= 0}"
                    label="Urlaub Saldo:"
                    :value="formateHolSaldo"
                    hide-details
                    disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-col>
      <v-col class="pt-3 pb-0 text-right" >
        <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
          &nbsp;Zurück
        </b-button>

      </v-col>
    </v-row>
    <v-row class="m-0">
      <v-col sm="3" md="2" xl="2">
        <v-select
            v-model="mita_select_value"
            :items="mita_select"
            filled
            hide-details
            label="Darstellungsart"
        ></v-select>
        <v-text-field v-if="mita_select_value !== 'Mitarbeitergruppen'" class="mt-1" prepend-inner-icon="mdi-magnify" hide-details single-line filled label="Suchen" v-model="search" clearable @click:clear="clearSearch"></v-text-field>
        <v-list v-if="mita_select_value === 'Mitarbeitergruppen'" style="max-height: 78vh; overflow-y: auto">
          <v-list-group
              v-for="(migr, j) in migrs"
              :key="j">
            <template v-slot:activator>
              <v-list-item-title v-text="migr"></v-list-item-title>
            </template>
            <v-list-item-group
                v-model="currentMita"
                @change="changeMita">
              <v-list-item
                  v-for="(mita, i) in sortedItems(migr)"
                  :key="mita.id"
                  :value="mita.id"
            >
                <v-list-item-content>
                  <v-list-item-title v-text="mita.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
        </v-list>
        <v-list v-else style="max-height: 72vh; overflow-y: auto">
          <v-list-item-group
              v-model="currentMita"
              color="primary"
              @change="changeMita"
          >
            <v-list-item
                v-for="(mita, i) in filteredItems"
                :key="mita.id"
                :value="mita.id"
            >
              <v-list-item-content>
                <v-list-item-title v-text="mita.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col>
        <v-card
            style="width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;">
        <v-calendar
            ref="calendar"
            v-model="focus"
            color="blue"
            :weekday-format="myDayFormat"
            :month-format="myMonthFormate"
            :events="events"
            :event-color="getEventColor"
            :event-ripple="false"
            @mousedown:day="startTime"
            @mousemove:day="throttledCallback"
            @mouseup:event="endTime"
            @mouseup:day="endTime"
            @mouseleave.native="cancelDrag"
            type="month"
            :weekdays="weekdayOrder"
            event-more-text="Mehr anzeigen"
            @click:more="viewDay"
        >
          <template v-slot:day-label="{day, present, month, year}">
            <v-row v-if="month==currentMonth" class="m-0" style="margin-top: -6px !important;">
              <v-col v-if="day-1 < userDays.length" class="p-1 text-left">
                <v-chip
                    :class="{'soll-ist':true, 'zero': !isFuture(day, present, month, year), 'undefined': isFuture(day, present, month, year)}"
                    label small
                  v-if="userDays[day-1].user_day.soll === 0.0"
              >
                Soll: {{userDays[day-1].user_day.soll}} Ist: {{roundToDigits(userDays[day-1].user_day.ist, 2)}}
              </v-chip>
                <v-chip
                    label
                    small
                    :class="{'soll-ist': true, 'neg': !isFuture(day, present, month, year), 'undefined': isFuture(day, present, month, year)}"
                    v-else-if="userDays[day-1].user_day.soll > userDays[day-1].user_day.ist"
                >
                  Soll: {{userDays[day-1].user_day.soll}} Ist: {{roundToDigits(userDays[day-1].user_day.ist, 2)}}
                </v-chip>
                <v-chip
                    label
                    small
                    class="soll-ist pos"
                    v-else
                >
                  Soll: {{userDays[day-1].user_day.soll}} Ist: {{roundToDigits(userDays[day-1].user_day.ist, 2)}}
                </v-chip>
              </v-col>
              <v-col v-if="!present" md="3" class="p-1"><v-btn fab  x-small depressed>{{day}}</v-btn></v-col>
              <v-col v-else md="3" class="p-1 text-left"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
            </v-row>
            <v-row v-else class="m-0" style="margin-top: -6px !important;">
              <v-col class="p-1" style="height: 40px"></v-col>
            </v-row>
          </template>
          <template v-slot:event="{ event, timed, eventSummary }" >
            <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']">
              <!--component :is="{ render: eventSummary }"></component-->
              <div class="v-event-summary" style="color: white">{{event.name}}</div>
            </div>
          </template>
        </v-calendar>
        </v-card>
        <!--v-overlay
            absolute
            :value="currentMita === undefined"
            style="margin: 12px"
            opacity="0.1"
        >
          <v-row>
            <v-col>
            </v-col>
          </v-row>
        </v-overlay-->
      </v-col>
    </v-row>
      <v-dialog
          v-model="showDialog"
          max-width="600px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Buchung für: {{formateCurrentBooking}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
              <v-col
              >
                <v-radio-group
                    v-model="lohnTypeSelect"
                    @change="lohnTypeChanged"
                    column
                >
                  <v-radio
                      :label="holliday_lohn.name"
                      color="#3F51B5"
                      value="holliday"
                  ></v-radio>
                  <v-radio
                      :label="ueberstunden_abgebaut_lohn.name"
                      color="#3F51B5"
                      value="ueb"
                  ></v-radio>
                  <v-radio
                      label="Fehlzeit"
                      color="#3F51B5"
                      value="fehl"
                  ></v-radio>
                  <v-radio
                      label="Erschwerniszuschlag"
                      color="#3F51B5"
                      value="ez"
                  ></v-radio>
                </v-radio-group>
                <v-select
                    v-model="selectedLohn"
                    :items="lohnSelects"
                    item-text="name"
                    item-value="id"
                    label="Lohnart"
                    hide-details="true"
                    return-object
                    no-data-text="Keine passenden Lohnarten gefunden."
                ></v-select>
                    <v-radio-group
                        v-model="bookTypeSelect"
                        row
                    >
                      <v-radio
                          label="Sollzeit ausbuchen"
                          color="#3F51B5"
                          value="day"
                          :disabled="cantBookWholeDay"
                      ></v-radio>
                      <v-radio
                          label="Stundenweise"
                          color="#3F51B5"
                          value="hour"
                          :disabled="cantBookHourly"
                      ></v-radio>
                    </v-radio-group>
              </v-col>
              </v-row>
                <v-row v-if="bookTypeSelect === 'hour'">
                  <v-col
                      cols="5"
                      sm="5"
                  >
                    <v-text-field
                        v-model="bookingStart"
                        label="Buchungsstart"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :error="errorStart"
                        :error-messages="errorMessageStart"
                        @click.stop="showTimePicker"
                    ></v-text-field>
                  </v-col>
                  <v-col style="display: flex;
                                align-items: center;
                                justify-content: center;">
                    <p class="m-0 font-2xl">−</p>
                  </v-col>
                  <v-col
                      cols="5"
                      sm="5"
                  >
                    <v-text-field
                        v-model="bookingEnd"
                        label="Buchungsende"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :error="errorEnd"
                        :error-messages="errorMessageEnd"
                        @click.stop="showTimePicker"

                    ></v-text-field>
                  </v-col>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelBooking"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onBook"
                :disabled="bookingDisabled"
            >
              Buchen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isConflict"
          max-width="1100px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Bitte beheben Sie folgende Konflikte</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table
                  :headers="taskHeaders"
                  :items="conflictingTasks"
                  :no-data-text="'Alle Konflikte wurden behoben. Bitte bestätigen Sie die Buchung.'"
                  hide-default-footer
                  disable-pagination
              >

                <template v-slot:item.date="{ item }">
                  <div class="py-2">
                    <div class="font-weight-bold text-subtitle-1">
                      {{ formatDate(item.main_todo.till) }}
                    </div>
                  </div>
                </template>

                <template v-slot:item.task_info="{ item }">
                  <div class="py-2">
                    <div class="font-weight-bold text-subtitle-2">
                      {{ item.aufgabe.subject }}
                    </div>

                    <div
                        class=" grey--text text-truncate "
                        style="max-width: 600px;"
                    >
                      {{ item.main_todo.message }}
                    </div>

                    <div
                        class="caption primary--text text-truncate"
                        style="max-width: 600px;"
                        v-if="item.users"
                    >
                      <v-icon x-small color="primary" class="mr-1" style="margin-bottom: 2px">mdi-account-group</v-icon>
                      {{ item.users }}
                    </div>
                  </div>
                </template>

                <template v-slot:item.ignore="{ item }">
                  <v-checkbox
                      v-model="item.solve"
                      hide-details
                      class="mt-0 pt-0"
                      color="green"
                      :true-value="'ignore'"
                      :false-value="''"
                  ></v-checkbox>
                </template>

                <template v-slot:item.move="{ item }">
                  <v-checkbox
                      style="width: 24px"
                      v-model="item.solve"
                      :true-value="'move'"
                      :false-value="''"
                      hide-details
                      class="mt-0 pt-0 justify-content-center"
                      color="green"
                  ></v-checkbox>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn icon @click="">
                    <v-icon color="blue">mdi-pencil</v-icon>
                  </v-btn>
                </template>

              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="isConflict = false"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onConfirm(true)"
                :disabled="!conflictHandled"
            >
              Beheben und Buchen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showTimeSelectDialog"
          max-width="500px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Soll: {{currentSoll}}  Ist: {{currentIst+currentBuchung}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-sheet outlined height="600">
                <v-calendar
                    style="padding-bottom: 25px; padding-top: 25px; border: none"
                    :value="currentDay"
                    ref="calendar_daily"
                    color="primary"
                    type="day"
                    :event-ripple="false"
                    locale="de-DE"
                    interval-minutes="15"
                    :interval-count="24 * 4"
                    :hide-header="true"
                    :short-intervals="false"
                    :interval-format="testInterval"
                    :interval-height="24"
                    :interval-style="intervalStyle"
                    :events="timeSelectionEvents"
                    :event-color="getEventColor"
                    @mousedown:time="startTimeTimeLine"
                    @mousemove:time="mouseMoveTimeLine"
                    @mouseup:time="endDragTimeLine"
                    @mouseleave.native="cancelDragTimeLine"
                >
                  <template v-slot:event="{ event, timed, eventSummary }">
                    <div class="v-event-draggable">
                      <component :is="{ render: eventSummary }"></component>
                    </div>
                    <div
                        v-if="event.name === 'Buchung'"
                        class="v-event-drag-bottom"
                        @mousedown.stop="extendBottomTimeLine(event)"
                    ></div>
                  </template>
                </v-calendar>
              </v-sheet>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                v-on:click.stop="cancelTimePicker"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                :disabled="createdEventTimeLine === null || createdEventTimeLine.start === createdEventTimeLine.end"
                v-on:click.st.stop="submitTimePicker"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showConfirm"
          max-width="500"
      >
        <v-card>
          <v-card-title class="text-h5">
            Buchung bestätigen
          </v-card-title>

          <v-card-text v-if="hoursToBook > 0.0 && selectedLohn">
            Soll die Buchung von <b>{{hoursToBook}}</b> Stunde{{hoursToBook === 1.0 ? "" : "n"}} <b>{{selectedLohn.name}}</b> durchgeführt werden ?
          </v-card-text>
          <v-card-text v-if="daysToBook > 0 && selectedLohn">
            Soll die Buchung von <b>{{daysToBook}}</b> Tag{{daysToBook === 1.0 ? "" : "e"}} <b>{{selectedLohn.name}}</b> durchgeführt werden ?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="green darken-1"
                text
                @click="onCancleConfirm"
            >
              Abbrechen
            </v-btn>

            <v-btn
                color="green darken-1"
                text
                @click="onConfirm(false)"
            >
              Buchung durchführen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"
import _throttle from "lodash/throttle"
import {decryptAES, decryptData, getUid} from "@/shared/crypto";

export default {
  name: "calendar",
  data: () => ({
    mita_select: ['Mitarbeitergruppen', 'Mitarbeiter'],
    mita_select_value: 'Mitarbeiter',
    focus: '',
    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,

    events: [],
    createEvent: null,
    bookEvent: null,
    createStart: null,
    overlay: true,
    currentMita: undefined,
    userDays: [],
    uebUsed: 0.0,
    uebPerformed: 0.0,
    uebPrevYear: 0.0,
    uebSaldo: 0.0,
    holGranted: 0.0,
    holUsed: 0.0,
    holPrevYear: 0.0,
    holSaldo: 0.0,
    breaks: [],

    holliday_lohn: {name: ""},
    ueberstunden_abgebaut_lohn: {name: ""},
    fehlzeiten: null,
    ezs: null,

    search: '',
    date: new Date().toISOString().substr(0, 7),
    modal: false,

    lohnSelects: [],
    selectedLohn: undefined,
    lohnTypeSelect: null,

    bookTypeSelect: null,
    bookingStart: null,
    bookingEnd: null,
    errorMessageStart: "",
    errorMessageEnd: "",

    showTimeSelectDialog: false,
    currentPause: null,
    currentWorkTime: null,
    timeSelectionEvents: [],
    currentDay: null,
    createEventTimeLine: null,
    createStartTimeLine: null,
    extendOriginalTimeLine: null,
    createdEventTimeLine: null,
    currentIst: 0.0,
    currentBuchung: 0.0,
    currentSoll: 0.0,

    showConfirm: false,
    hoursToBook: 0.0,
    daysToBook: 0,

    conflictingTasks: [],
    bhStructure: [],
    isConflict: false,
    taskHeaders: [
      { text: 'Datum', value: 'date', width: '120px' },
      // We map this to a virtual value 'task_info' to group the name/desc/users
      { text: 'Aufgabe', value: 'task_info', sortable: false },
      { text: 'Ignorieren', value: 'ignore', sortable: false, align: 'center', width: '100px' },
      { text: 'Verschieben', value: 'move', sortable: false, align: 'center', width: '100px' },
      { text: 'Bearbeiten', value: 'actions', sortable: false, align: 'center', width: '100px' },
    ],
  }),
  computed: {
    conflictHandled() {
      let handled = true;
      for (let i = 0; i < this.conflictingTasks.length; i++) {
        if (this.conflictingTasks[i].solve === '') {
          return false
        }
      }
      return handled
    },
    formatedDate() {
        let splits = this.date.split("-");
        console.log(this.date)
        return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
    showDialog() {
      return this.bookEvent !== null;
    },
    formateUebUsed() {
      return this.uebUsed.toLocaleString('de-DE') + (Math.abs(this.uebUsed.abs) === 1.0 ? " Stunde":" Stunden")
    },
    formateUebPrevYear() {
      return this.uebPrevYear.toLocaleString('de-DE') + (Math.abs(this.uebPrevYear.abs) === 1.0 ? " Stunde":" Stunden")
    },
    formateUebPerformed() {
      return this.uebPerformed.toLocaleString('de-DE') + (Math.abs(this.uebPerformed.abs) === 1.0 ? " Stunde":" Stunden")
    },
    formateUebSaldo() {
      return this.uebSaldo.toLocaleString('de-DE') + (Math.abs(this.uebSaldo) === 1.0 ? " Stunde":" Stunden")
    },

    formateHolUsed() {
      return this.holUsed.toLocaleString('de-DE') + (Math.abs(this.holUsed) === 1.0 ? " Tag":" Tage")
    },
    formateHolGranted() {
      return this.holGranted.toLocaleString('de-DE') + (Math.abs(this.holGranted) === 1.0 ? " Tag":" Tage")
    },
    formateHolPrevYear() {
      return this.holPrevYear.toLocaleString('de-DE') + (Math.abs(this.holPrevYear) === 1.0 ? " Tag":" Tage")
    },
    formateHolSaldo() {
      return this.holSaldo.toLocaleString('de-DE') + (Math.abs(this.holSaldo) === 1.0 ? " Tag":" Tage")
    },
    formateCurrentBooking() {
      if (this.bookEvent) {
          let event = this.$refs.calendar.parseEvent(this.bookEvent);
          if (event.start.day === event.end.day) {
            let date = event.start.date.split("-");
            return date[2]+"."+date[1]+"."+date[0]
          } else {
            let date1 = event.start.date.split("-");
            let date2 = event.end.date.split("-");
            return date1[2]+"."+date1[1]+"."+date1[0]+" - " +  date2[2]+"."+date2[1]+"."+date2[0]
          }
      }
      return ""
    },
    cantBookHourly() {
      if (this.bookEvent) {

        let event = this.$refs.calendar.parseEvent(this.bookEvent);
        if (event.start.day !== event.end.day) {
          return true;
        }
        if (this.lohnTypeSelect === "holliday" || this.lohnTypeSelect === "ueb" || this.lohnTypeSelect === "fehl") {
          if (this.userDays[event.start.day-1].user_day.ist >= this.userDays[event.start.day-1].user_day.soll) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    cantBookWholeDay() {
      if (this.bookEvent) {
        if (this.lohnTypeSelect === "ez" || this.lohnTypeSelect === "lohn" || this.lohnTypeSelect === "time") {
          return true
        }
        let event = this.$refs.calendar.parseEvent(this.bookEvent);
        let dayBookable = 0;
        for (let i = event.start.day-1; i < event.end.day; i++) {
          if (this.userDays[i].user_day.ist > 0.0 && this.userDays[i].user_day.soll !== 0.0) {
            return true;
          } else if (this.userDays[i].user_day.soll !== 0.0) {
            dayBookable += 1;
          }
        }
        if (dayBookable === 0) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    getMaxTimeStart() {
      if (this.bookingEnd) {
        return this.bookingEnd;
      } else {
        return "23:59";
      }
    },
    getMinTimeEnd() {
      if (this.bookingStart) {
        return this.bookingStart;
      } else {
        return "00:00";
      }
    },
    bookingDisabled() {
      return !(this.selectedLohn !== undefined && this.bookTypeSelect !== null && (this.bookTypeSelect === 'day' || (this.bookingStart !== null && this.bookingEnd !== null)));
    },
    errorStart() {
      return this.errorMessageStart !== ""
    },
    errorEnd() {
      return this.errorMessageEnd !== ""
    }
  },
  mounted () {
    this.$refs.calendar.updateTimes()
    this.currentMonth = this.$refs.calendar.parsedValue.month;
    this.currentYear = this.$refs.calendar.parsedValue.year;
  },
  created() {
    this.throttledCallback = _throttle(this.mouseMove, 30);
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users'
    ).then(this.responseOkGet, this.responseError)
    },
  watch: {
    lohnTypeSelect(newVal) {
      if (this.cantBookWholeDay && this.bookTypeSelect === 'day' && !this.cantBookHourly) {
        this.bookTypeSelect = "hour";
      } else {
        this.bookTypeSelect = undefined;
      }
    },
  },
  methods: {
    formatDate(d) {
      d = d.split("T")[0];
      let split = d.split("-");
      return split[2] + "." + split[1] + "." + split[0];
    },
    async decryptMemo(description) {
      return await decryptAES(sessionStorage.getItem("aes"), description);
    },
    moveDate(direction) {
      let curDate = new Date(this.date + "-01");
      let date = new Date(curDate.setMonth(curDate.getMonth() + direction)).toISOString().substring(0, 7);
      this.setDate(date);
    },
    testInterval(a) {
      if (a.minute === 0) {
        return a.time;
      }
    },
    intervalStyle(a) {
      if (this.currentWorkTime !== null && this.currentWorkTime.soll_zeit.split("-").length === 2) {
        if (a.time >= this.currentWorkTime.soll_zeit.split("-")[0] && a.time < this.currentWorkTime.soll_zeit.split("-")[1])
          return {backgroundColor: "lightyellow"}
      }
    },
    showTimePicker() {
      this.currentPause= null;
      this.currentWorkTime= null;
      this.timeSelectionEvents= [];
      this.currentDay= null;
      this.createEventTimeLine= null;
      this.createStartTimeLine= null;
      this.extendOriginalTimeLine= null;
      this.createdEventTimeLine= null
      let event = this.$refs.calendar.parseEvent(this.bookEvent);
      this.currentDay = event.start.date;
      let userday = this.userDays[event.start.day-1];
      let pausen = [];
      if (userday.user_time.pause_1 !== "00:00-00:00" && userday.user_time.pause_1.split("-").length === 2) {
          let pausSplit = userday.user_time.pause_1.split("-");
          let p = {
            id: getUid(),
            name: "Pause",
            start: new Date(`${userday.date}T${pausSplit[0]}:00`),
            end: new Date(`${userday.date}T${pausSplit[1]}:00`),
            color: "#525151",
            timed: true,
          }
          pausen.push(p);
      }
      if (userday.user_time.pause_2 !== "00:00-00:00" && userday.user_time.pause_2.split("-").length === 2) {
        let pausSplit = userday.user_time.pause_2.split("-");
        let p = {
          id: getUid(),
          name: "Pause",
          start: new Date(`${userday.date}T${pausSplit[0]}:00`),
          end: new Date(`${userday.date}T${pausSplit[1]}:00`),
          color: "#525151",
          timed: true,
        }
        pausen.push(p);
      }
      /*if (pausen.length === 0) {
        for (let i = 0; i < this.breaks.length; i++) {
          let b = this.breaks[i];
          let valid = false;
          switch (event.start.weekday) {
            case 0:
              valid = b.so;
              break;
            case 1:
              valid = b.mo;
              break;
            case 2:
              valid = b.di;
              break;
            case 3:
              valid = b.mi;
              break;
            case 4:
              valid = b.do;
              break;
            case 5:
              valid = b.fr;
              break;
            case 6:
              valid = b.sa;
              break;
          }
          if (valid) {
            let von = b.von.match(/.{2}/g).join(":");
            let bis = b.bis.match(/.{2}/g).join(":");
            let p = {
              id: getUid(),
              name: "Pause",
              start: new Date(`${userday.date}T${von}:00`),
              end: new Date(`${userday.date}T${bis}:00`),
              color: "#525151",
              timed: true,
            }
            pausen.push(p);
          }
        }
      }*/
      this.currentPause = pausen;
      let currentEvents = [];
      for (let i = 0; i < userday.user_day_splits.length; i++) {
        let split = userday.user_day_splits[i];
        let start = new Date(`${split.date}T${split.von}:00`)
        let end = new Date(`${split.date}T${split.bis}:00`)
        let name = split.von + "-" + split.bis;
        let color = "#000";
        switch (split.type) {
          case "ARBL":
            color = "#328f33";
            name =  "Arbeit";
            break;
          case "FEHL":
            color = "#ea5324"
            name = "Fehlzeit";
            break;
          case "HOLL":
            color = "#095996";
            name = "Urlaub";
            break;
          case "PAUS":
            color = "#525151";
            name = "Pause";
            break
        }
        currentEvents.push({
          id: split.id,
          name: name,
          start: start,
          end: end,
          color: color,
          timed: true,
        })
      }
      let validPausen = []
      for (let i = 0; i < this.currentPause.length; i++) {
        let valid = true;
        for (let j = 0; j < currentEvents.length; j++) {
          if ((this.currentPause[i].start <= currentEvents[j].end) && (this.currentPause[i].end >=  currentEvents[j].start)) {
            valid = false;
            break;
          }
        }
        if (valid) {
          validPausen.push(this.currentPause[i]);
        }
      }
      this.currentSoll = userday.user_day.soll;
      this.currentIst = userday.user_day.ist;
      this.currentBuchung = 0.0;
      this.showTimeSelectDialog = true;
      this.currentWorkTime = userday.user_time;
      this.timeSelectionEvents = currentEvents.concat(validPausen);
      this.$nextTick(() => {
        setTimeout(() => this.$refs.calendar_daily.scrollToTime('07:00'), 150);
      });

      this.clearError();
    },
    cancelTimePicker() {
      this.showTimeSelectDialog = false;
      this.currentPause= null;
          this.currentWorkTime= null;
          this.timeSelectionEvents= [];
          this.currentDay= null;
          this.createEventTimeLine= null;
          this.createStartTimeLine= null;
          this.extendOriginalTimeLine= null;
          this.createdEventTimeLine= null
    },
    submitTimePicker() {
        let parsed = this.$refs.calendar_daily.parseEvent(this.createdEventTimeLine);
        this.bookingStart = parsed.start.time;
        this.bookingEnd = parsed.end.time;
        this.cancelTimePicker();
    },
    clearError() {
      this.errorMessageStart = "";
      this.errorMessageEnd = "";
    },
    onBook() {
      if(this.bookTypeSelect === "day") {
        // pretty simple, just notify the server about the days and kind of booking
        this.hoursToBook = 0.0;
        this.daysToBook = 0;
        switch (this.selectedLohn.lohn_usage_type) {
          case "PE02":
            // hours
              let hoursToBook = 0;
            let event1 = this.$refs.calendar.parseEvent(this.bookEvent);
            for (let i = event1.start.day-1; i < event1.end.day; i++) {
              hoursToBook += this.userDays[i].user_day.soll;
            }
            this.hoursToBook = hoursToBook;
                break;
          case "PE05":
            // days
            let daysToBook = 0;
            let event2 = this.$refs.calendar.parseEvent(this.bookEvent);
            for (let i = event2.start.day-1; i < event2.end.day; i++) {
              if (this.userDays[i].user_day.soll > 0.0) {
                daysToBook += 1;
              }
            }
            this.daysToBook = daysToBook;
                break;
        }
        this.showConfirm = true;
      } else {
        // first check if start and end ist different
        if (this.bookingStart === this.bookingEnd) {
          this.errorMessageStart = this.errorMessageEnd = "Die Zeiten müssen unterschiedlich sein."
          return
        }
        this.hoursToBook = 0.0;
        this.daysToBook = 0;
        let minutesStart = parseInt(this.bookingStart.split(":")[0]) * 60 + parseInt(this.bookingStart.split(":")[1]);
        let minutesEnd = parseInt(this.bookingEnd.split(":")[0]) * 60 + parseInt(this.bookingEnd.split(":")[1]);
        let dayRelativeDifference = minutesEnd - minutesStart;
        if (minutesEnd === 0) {
          dayRelativeDifference += 24*60;
        }
        let difInHours = dayRelativeDifference / 60.0;
        switch (this.selectedLohn.lohn_usage_type) {
          case "PE02":
            // hours
            this.hoursToBook = difInHours;
            break;
          case "PE05":
            // days
            let event2 = this.$refs.calendar.parseEvent(this.bookEvent);
            let soll = this.userDays[event2.start.day-1].user_day.soll;
            let percentage = this.toNearestQtr(difInHours / soll);
            this.daysToBook = percentage;
            break;
        }
        this.showConfirm = true;
      }
    },
    toNearestQtr(number) {
      let qtr = (Math.round(number * 4) / 4).toFixed(2);
      if (qtr < 0.25) {
        return 0.25
      } else if (qtr > 1.0) {
        return 1.0
      }
      return qtr;
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    clearSearch () {
      this.search="";
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
            this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.holliday_lohn = response.body.holliday_lohn;
        this.ueberstunden_abgebaut_lohn = response.body.ueberstunden_abgebaut_lohn;
        this.fehlzeiten = response.body.fehlzeiten;
        this.ezs = response.body.ezs;
        this.lohnSelects =[this.holliday_lohn];
        this.selectedLohn = this.holliday_lohn;
        this.lohnTypeSelect = "holliday";
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
    },
    responseOkReload(response) {
      if (response.status === 200) {
        let mita = this.getCurrentMita(this.currentMita);
        this.$http.get(
            Server_URL_ZK + '/zk/overview/' + mita.bis_id + "?month=" + this.currentMonth + "&year=" + this.currentYear
        ).then(this.responseOkGetOverview, this.responseError)
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },

    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.userDays = response.body.overviews;
        this.uebUsed = response.body.ueb_used;
        this.uebPerformed = response.body.ueb_performed;
        this.uebPrevYear = response.body.ueb_prev_year;
        this.uebSaldo = response.body.ueb_saldo;

        this.holGranted = response.body.holGranted;
        this.holUsed = response.body.holUsed;
        this.holUsed = response.body.holUsed;
        this.holPrevYear = response.body.holPrevYear;
        this.holSaldo = response.body.holSaldo;

        this.breaks = response.body.pausen;
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    getName(structure, id) {
      if (structure === null) {
        return "";
      } else if (structure.length === 0) {
        return "";
      }
      let res = '';
      for (let i = 0; i < structure.length; i++) {
        if (structure[i].id === id) {
          return structure[i].name;
        } else {
          res += this.getName(structure[i].children, id);
        }
      }
      return res;
    },
    async responseError(response) {
      this.hideLoader();
      if (response.status === 409) {
        for (let i = 0; i < response.body.intersections.length; i++) {
          response.body.intersections[i].solve = '';
          response.body.intersections[i].users = "";
        }
        this.conflictingTasks = response.body.intersections;
        this.bhStructure = response.body.bh_structure;
        for (let i = 0; i < this.conflictingTasks.length; i++) {
          this.conflictingTasks[i].main_todo.message = await decryptAES(sessionStorage.getItem("aes"), this.conflictingTasks[i].main_todo.message);
          let me = this.conflictingTasks[i].main_todo.user_id;
          let plannedFor = [];
          for (let j = 0; j < this.conflictingTasks[i].all_todos.length; j++) {
            let user = this.conflictingTasks[i].all_todos[j].user_id;
            if (user !== me) {
              if (user.startsWith("KOST") || user.startsWith("MIGR")) {
                plannedFor.push(this.getName(this.bhStructure, user));
              } else {
                let res = JSON.parse(sessionStorage.getItem(user));
                if (res !== null) {
                  plannedFor.push(res.first_name + " " + res.surname);
                }
              }
            }
          }
          this.conflictingTasks[i].users = plannedFor.join(", ");
        }
        this.isConflict = true;
        console.log(response.body)
      } else if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    changeMita(mitaId) {
      if (mitaId !== undefined) {
        let mita = this.getCurrentMita(mitaId);
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/overview/' + mita.bis_id + "?month=" + this.currentMonth + "&year=" + this.currentYear
        ).then(this.responseOkGetOverview, this.responseError)
      } else {
        this.userDays = [];
        this.calculateEvents();
      }
    },
    setDate(date) {
      this.$refs.dialog.save(date);
      this.date = date;
      this.focus = date+"-01";
      this.$nextTick(() => {
        this.currentMonth = this.$refs.calendar.parsedValue.month;
        this.currentYear = this.$refs.calendar.parsedValue.year;
        this.changeMita(this.currentMita);
      });
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    startTime (tms) {
      if (tms.month !== this.currentMonth || this.bookEvent || this.currentMita === undefined) {
        return;
      }
      const mouse = this.toTime(tms)
        if (this.createEvent) {
          this.bookEvent = this.createEvent;
          this.createEvent = null
          this.createStart = null
          return
        }
      this.createStart = this.roundTime(mouse)
        this.createEvent = {
          id: 'created',
          name: `Neue Buchung`,
          color: "#e0d414",
          start: this.createStart,
          end: this.createStart,
          timed: true,
        }

        this.events.push(this.createEvent)

    },
    endTime() {
      if (this.createEvent) {
        this.bookEvent = this.createEvent;
        this.createEvent = null
        this.createStart = null
      }
    },
    mouseMove (tms) {
      if (tms.month !== this.currentMonth) {
        return;
      }
      const mouse = this.toTime(tms)

      if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)

        this.createEvent.start = min
        this.createEvent.end = max
      }
    },
    cancelDrag () {
      if (this.createEvent) {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
      }

      this.createEvent = null
      this.createStart = null
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return Math.round(number * roundTo) / roundTo
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.createEventTimeLine
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : event.color
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    calculateEvents() {
      let events = [];
      for (let i = 0; i < this.userDays.length; i++) {
        let e = null;
        let eF = null;
        for (let j = 0; j < this.userDays[i].user_day_splits.length; j++) {
          let split = this.userDays[i].user_day_splits[j];
          if (split.type !== "PAUS") {
            let start = new Date(`${split.date}T${split.von}:00`)
            let end = new Date(`${split.date}T${split.bis}:00`)
            let name = split.von + "-" + split.bis;
            let color = "#000";
            switch (split.type) {
              case "ARBL":
                color = "#328f33";
                name =  name + " Arbeit";
                if (e != null) {
                  events.push(e);
                  e = null;
                }
                if (eF != null) {
                  events.push(eF);
                  eF = null;
                }
                events.push({
                  id: split.id,
                  name: name,
                  start: start,
                  end: end,
                  color: color,
                  timed: false,
                })
                break;
              case "FEHL":
                color = "#ea5324"
                name = "F " + name;
                if (e != null) {
                  events.push(e);
                  e = null;
                }
                if (eF != null) {
                  eF.end = end;
                  eF.name = eF.name.split("-")[0] + "-" + split.bis;
                  console.log("eF was not null")
                  console.log(eF)
                } else {
                  eF = {
                    id: split.id,
                    name: name,
                    start: start,
                    end: end,
                    color: color,
                    timed: false,
                  }
                }
                break;
              case "HOLL":
                color = "#095996";
                name = "U " + name;
                if (eF != null) {
                  events.push(eF);
                  eF = null;
                }
                if (e != null) {
                  e.end = end;
                  e.name = e.name.split("-")[0] + "-" + split.bis;
                  console.log("e was not null")
                  console.log(e)
                } else {
                  e = {
                    id: split.id,
                    name: name,
                    start: start,
                    end: end,
                    color: color,
                    timed: false,
                  }
                }
            }
          }
        }
        if (e != null) {
          events.push(e);
          e = null;
        }
        if (eF != null) {
          events.push(eF);
          eF = null;
        }
      }
      this.events = events;
    },
    viewDay(a,e) {
        if (this.createEvent) {
          this.createEvent = null
          this.createStart = null
          this.dragTime = null
          this.dragEvent = null
          return
        }
      e.stopPropagation();
    },
    lohnTypeChanged(input) {
      switch (input) {
        case "holliday":
          this.lohnSelects =[this.holliday_lohn];
          this.selectedLohn = this.holliday_lohn;
          break
        case "ueb":
          this.lohnSelects =[this.ueberstunden_abgebaut_lohn];
          this.selectedLohn = this.ueberstunden_abgebaut_lohn;
          break
        case "fehl":
          this.lohnSelects =this.fehlzeiten;
          this.selectedLohn = undefined
          break
        case "ez":
          this.lohnSelects =this.ezs;
          this.selectedLohn = undefined
          break
      }
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    onCancelBooking() {
      if (this.bookEvent) {
        const i = this.events.indexOf(this.bookEvent)
        if (i !== -1) {
          this.events.splice(i, 1)
        }
      }
      this.lohnSelects =[this.holliday_lohn];
      this.selectedLohn = this.holliday_lohn;
      this.lohnTypeSelect = "holliday";
      this.bookTypeSelect = null;
      this.bookingStart = null;
      this.bookingEnd = null;
      this.errorMessageStart = "";
      this.errorMessageEnd = "";
      this.bookEvent = null;
    },

    startTimeTimeLine (tms) {
      if (this.createdEventTimeLine) {
        return
      }
      const mouse = this.roundTime(this.toTime(tms));
      let start = mouse;
      let end = mouse;
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let blocked = this.timeSelectionEvents[i];
        if (blocked.name !== "Buchung" && (start < blocked.end)  &&  (end > blocked.start)) {
            return;
        }
      }

        this.createStartTimeLine = this.roundTime(mouse)
        this.createEventTimeLine = {
          name: `Buchung`,
          color: "#000000",
          start: this.createStartTimeLine,
          end: this.createStartTimeLine,
          timed: true,
        };
      this.createdEventTimeLine = this.createEventTimeLine;
        this.timeSelectionEvents.push(this.createEventTimeLine)
    },
    extendBottomTimeLine (event) {
      this.createEventTimeLine = event
      this.createStartTimeLine = event.start
      this.extendOriginalTimeLine = event.end
    },
    mouseMoveTimeLine (tms) {
      const mouse = this.toTime(tms)
      if (this.createEventTimeLine && this.createStartTimeLine !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStartTimeLine)
        const max = Math.max(mouseRounded, this.createStartTimeLine)
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let blocked = this.timeSelectionEvents[i];
          if (blocked.name !== "Buchung" && (min < blocked.end)  &&  (max > blocked.start)) {
            return;
          }
        }
        let dateA = new Date(min);
        let dateB = new Date(max);
        let dayRelativeDifference =   dateB.getHours()*60 + dateB.getMinutes()
            - dateA.getHours()*60 - dateA.getMinutes();
        if (dateB.getDay() > dateA.getDay()) {
          dayRelativeDifference += 24*60;
        }
        let difInHours = dayRelativeDifference / 60.0;
        if (this.currentSoll < this.currentIst + difInHours) {
          return;
        }
        this.currentBuchung = difInHours;

        this.createEventTimeLine.start = min
        this.createEventTimeLine.end = max
      }
    },
    endDragTimeLine () {
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
    },
    cancelDragTimeLine () {
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
    },
    /*getEventColor(event) {
      return event.color;
    }*/
    onCancleConfirm() {
      this.showConfirm = false;
    },
    onConfirm(ignore = false) {
      this.isConflict = false;
      // todo send request to server, hide dialogs, reset dialog data
      let mita = this.getCurrentMita(this.currentMita);
      let event2 = this.$refs.calendar.parseEvent(this.bookEvent);
      let data = {
        user_gischl: mita.bis_id,
        lohn_id: this.selectedLohn.id,
        book_whole_day: this.bookTypeSelect === "day",
        start_date: event2.start.date,
        end_date: event2.end.date,
        ignore_conflict: ignore,
      }
      if (this.bookTypeSelect !== "day") {
          data.start_time = this.bookingStart;
          data.end_time = this.bookingEnd;
      }
      this.showLoader();
      this.showConfirm = false;
      this.onCancelBooking()
      this.$http.post(
          Server_URL_ZK + '/zk/overview_book/' + mita.bis_id + "?month=" + this.currentMonth + "&year=" + this.currentYear, data
      ).then(this.responseOkReload, this.responseError)
    },
    onBack() {
      window.history.back();
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month-1, day);
      return date > today;
    }
  }
}
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.undefined {
  background-color: rgb(161, 149, 149) !important;
  border-color: rgb(161, 149, 149) !important;
  color: white;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}

</style>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #e4e5e6 !important;
}

::v-deep .v-list-item--link:before {
  background-color: transparent;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}


::v-deep .v-list-item {
  min-height: 36px!important;
  padding: 0 8px!important;
}

::v-deep .v-list-item__content {
  padding: 8px 0!important;
}

</style>
